var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ color: this.value < 0 ? 'red' : 'green' })},[_vm._v(" "+_vm._s(Math.max(0, this.value))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }